import './theme_espoo.scss'
import ITheme from '../ITheme';

export default class ThemeEspoo implements ITheme {
    id: string = "espoo";
    cssClassName: string = "theme_espoo";
    dark: boolean = false;
    menuRight: boolean = true;
    menuDark: boolean = false;
    toolbarDark: boolean = false;
    appNameI18n: string = "toolbar.app_name_transportation_services"
    vuetifyTheme: any = {
        primary: '#0047b6',
        secondary: '#00ff00',
        accent: '#0047b6',
        warning: '#00b7f1'
    }
}
